import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastViewportComponent } from '@sandbox-platform/shared-ui';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastViewportComponent],
  templateUrl: './app.html',
})
export class AppComponent {}
